module.exports = __webpack_public_path__ + "img/hygh.26a5d752.jpg";